import { ThemeProvider, CssBaseline } from '@mui/material';
import { GlobalSnackbarProvider, GlobalConfirmProvider } from 'components/GlobalSnackbar';
import { ThemeModeProvider } from 'components/AppShell';
import { useAuth } from 'hooks/useAuth';
import AppRouter from 'core/router/AppRouter';
import theme from 'core/theme';
import 'components/AppShell/tokens.css';

function App() {
  // Инициализируем данные пользователя при загрузке приложения
  useAuth();

  return (
    <ThemeModeProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalConfirmProvider>
          <GlobalSnackbarProvider>
            <AppRouter />
          </GlobalSnackbarProvider>
        </GlobalConfirmProvider>
      </ThemeProvider>
    </ThemeModeProvider>
  );
}

export default App;
